import { render, staticRenderFns } from "./orderLabelTag.vue?vue&type=template&id=87cebe78&scoped=true&"
import script from "./orderLabelTag.vue?vue&type=script&lang=js&"
export * from "./orderLabelTag.vue?vue&type=script&lang=js&"
import style0 from "./orderLabelTag.vue?vue&type=style&index=0&id=87cebe78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cebe78",
  null
  
)

export default component.exports